import { render, staticRenderFns } from "./PageNewRole.vue?vue&type=template&id=ee383058"
import script from "./PageNewRole.vue?vue&type=script&lang=js"
export * from "./PageNewRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports